// extracted by mini-css-extract-plugin
export default {"header":"Header_header__-azap","toolbar":"Header_toolbar__Xwj95"};